module.exports = {"buildVersion":"2.26.1-230102284","release":"2.26.1","buildDateTime":"Mon Jan 02 2023 09:28"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 1818
// module chunks = 23